export const genderRoutes = {
	genderIndex: '/genders'
} as const
